import { useMutation } from '@tanstack/react-query';
import type { CustomersRelationshipsRequestBody } from '@customerio/hydra-ui-api';
import { hydraUiApi } from '@/services/api';
import type { HookMutationConfig } from '../shared/react-query-types';
import { requireWorkspaceId } from '../shared/workspace';

type Relationship = CustomersRelationshipsRequestBody['relationships'][number];

export async function createRelationships(workspaceId: number, relationships: Relationship[]): Promise<void> {
  await hydraUiApi.customers.createRelationships({
    params: { path: { environment_id: String(workspaceId) } },
    body: { relationships },
  });
}

export function useCreateRelationships(options: { mutationConfig?: HookMutationConfig<void, Relationship[]> } = {}) {
  const workspaceId = requireWorkspaceId();
  return useMutation({
    ...options.mutationConfig,
    mutationFn: (relationships: Relationship[]) => createRelationships(workspaceId, relationships),
  });
}
